import React, { useState, useCallback, useMemo } from 'react';

// style
import {
    FormWrapper,
    InputWrapper,
    LabelWrapper,
    SpanWrapper,
    BtnWrapper,
    InfoWrapper,
} from '../assets/styles/form';

// asset
import Btn from '../assets/images/btn.png';

// component
import { useAlert } from '../../../components/common/Alert';

// service
import CouponService from '../../../services/CouponService';

// util
import { useMatch } from "@reach/router"
import _ from 'lodash';

const useInputChange = (setter) => useCallback(e => setter(e.target.value), [setter]);

const useInput = (initValue, initPlaceholder, maxLength = 36) => {
    const [value, setValue] = useState(initValue);
    const [placeholder, setPlaceholder] = useState(initPlaceholder);

    const onChange = useCallback(e => {
        const value = e.target.value;
        if (value !== '' && value.length > maxLength)
            return;

        setValue(value);
    }, [maxLength]);

    const onFocus = useCallback(() => {
        setPlaceholder('');
    }, []);

    const onBlur = useCallback(() => {
        setPlaceholder(initPlaceholder);
    }, [initPlaceholder]);

    const props = { placeholder, onFocus, onBlur };

    return [value, onChange, props];
}

// url에서 쿠폰번호가 있을 경우 반환. 그렇지 않으면 공배 반환
const useInitCouponNum = () => {
    const match = useMatch('/coupon/:couponNum');
    return match ? match.couponNum : '';
}

const Form = ({ scrollRef }) => {
    const initCouponNum = useInitCouponNum();

    // form에 store입력 필드가 없기 때문에 google롤 고정한다
    const [store, setStore] = useState('google');
    const [userId, setUserId, userIdInputProps] = useInput('', '계정 UID를 입력해주세요', 36);
    const [couponNum, setCouponNum, couponNumInputProps] = useInput(initCouponNum, '쿠폰 번호를 입력해주세요', 16);

    const onStoreChanged = useInputChange(setStore);

    const moveToCheckUID = useCallback(() => {
        const dims = scrollRef.current.getBoundingClientRect();
        // window.scrollTo(window.scrollX, dims.top - 30);
        window.scrollTo({ top: dims.top - 25, behavior: "smooth" });

    }, [scrollRef]);

    const alert = useAlert();

    const onOk = useCallback(async () => {
        if (_.isEmpty(userId)) {
            alert('계정 UID를 입력해주세요');
            return;
        }

        if (_.isEmpty(couponNum)) {
            alert('쿠폰 번호를 입력해주세요');
            return;
        }

        try {
            await CouponService.use(store, userId, couponNum);

            alert('보상이 지급되었습니다.\n우편함을 확인해주세요.');
        } catch (e) {
            console.error(e);

            alert(e.message || e.toString());
        }
    }, [store, userId, couponNum, alert]);

    return (
        <>
            {/*  */}
            <FormWrapper>
                <h1 className="sr-only">쿠폰입력폼</h1>
                <div className="uidInfo">
                    <LabelWrapper htmlFor="uid">계정 UID</LabelWrapper>
                    <SpanWrapper onClick={moveToCheckUID}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                        >
                            <path
                                fillRule="evenodd"
                                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z"
                                clipRule="evenodd"
                            />
                        </svg>
                        계정 UID 확인 방법
                    </SpanWrapper>
                </div>
                <InputWrapper
                    id="uid"
                    type="text"
                    onChange={setUserId}
                    value={userId}
                    {...userIdInputProps}
                />
                {/* //////////////// */}
                <LabelWrapper htmlFor="couponId">쿠폰번호</LabelWrapper>
                <InputWrapper
                    id="couponId"
                    type="text"
                    onChange={setCouponNum}
                    value={couponNum}
                    {...couponNumInputProps}
                />
                {/* 안내문구 */}
                <InfoWrapper>
                    <li>* 이미 사용 된 쿠폰은 등록 할 수 없습니다.</li>
                    <li>* 하나의 계정당 종류별로 한 개의 쿠폰만 등록 가능합니다.</li>
                    <li>* 쿠폰 사용 시 우편함으로 보상이 지급됩니다.</li>
                </InfoWrapper>

                {/* 제출 버튼 */}
                <BtnWrapper src={Btn} alt="button" onClick={onOk} />
            </FormWrapper>
        </>
    );
}

export default Form;